export function getSizeValue(value: string | number): string {
    if (typeof value === 'number') {
        // If the value is a number then we convert to px
        return `${value}px`;
    }
    return value;
}
